var map = {
	"./bg2.png": "4f38",
	"./bszl.png": "4610",
	"./bszn.png": "a369",
	"./djbl.png": "e947",
	"./dw.png": "7a97",
	"./dzjg.png": "b700",
	"./dzzzcx.png": "af0b",
	"./flfg.png": "9442",
	"./flfg1.png": "a5bf",
	"./gsgg.png": "959d",
	"./gsgg1.png": "142e",
	"./hz.png": "53bb",
	"./icon-1.png": "1528",
	"./jdcx.png": "ca62",
	"./logo.png": "1231",
	"./logo2.png": "efab",
	"./logo2_new.png": "596c",
	"./logo3.png": "43be",
	"./service-icon6.png": "802a",
	"./title-icon.png": "b7c2",
	"./wsyy.png": "5ea2",
	"./wxUrl-zs.png": "86a4",
	"./wxUrl.png": "e05a",
	"./wxgzh-8cm.jpg": "8f91",
	"./wybl.png": "8e10",
	"./wycx.png": "f8bf",
	"./wyyy.png": "daaf",
	"./xjbdcdjwsdx.png": "193b",
	"./xxcx.png": "f4e9",
	"./zcbg.png": "1832",
	"./zcfg.png": "c1acd",
	"./zxjf.png": "a7ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38b1";